import { render, staticRenderFns } from "./SearchableDropdownInput.vue?vue&type=template&id=faafe9da&"
import script from "./SearchableDropdownInput.vue?vue&type=script&lang=ts&"
export * from "./SearchableDropdownInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports